export default __webpack_public_path__ + "static/media/visa.41f9c7ad.svg";